import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, ModalBody, Row, Col, Button } from 'reactstrap';
import { LoadingButton } from 'vl-common/src/components/LoadingButton';
import useApi from 'vl-common/src/hooks/useApi';
import { ErrorModal } from 'vl-common/src/components/Modals/CustomModals/Error';

const ResentInvite = ({
  title = 'Resend Invitation?',
  subText = 'Are you sure you want to resend the invitation?',
  cancelBtnHandler,
  onComplete,
  data,
  ...restProps
}) => {
  const { t } = useTranslation('common');
  const { Api, consumed } = useApi();
  const [loading_create, setLoading_create] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const sendBtnHandler = () => {
    setLoading_create(true);

    Api.referrer
      .resendInvitationEmailNew(data.user_guid)
      .then((res) => {
        console.debug('Resend Email response:', res);
        setLoading_create(false);
        if (onComplete) {
          onComplete();
        }
      })
      .catch((e) => {
        setLoading_create(false);

        const status = e.response?.status;

        if (status === 400 || status === 429) {
          consumed(e);

          let errorMsg: string;

          if (!errorMsg) {
            if (status === 429) {
              errorMsg = 'This invitation was recently sent. Please wait a few minutes before trying again.';
            } else {
              errorMsg = 'Unable to resend the invitation. Please try again later.';
            }
          }

          setErrorMessage(errorMsg);
          setErrorModalOpen(true);

          if (cancelBtnHandler) {
            cancelBtnHandler();
          }
        }
      });
  };

  return (
    <>
      <Modal size="lg" {...restProps} centered backdrop={'static'} keyboard={false} data-testid="resent-invite-modal">
        <ModalBody>
          <Row style={styles.container}>
            <Col className="vl-flex-col-start-start">
              <div style={styles.titleHolder}>
                <span style={styles.title}>{title}</span>
              </div>
              <div style={styles.subText}>{subText}</div>
              <div className="vl-flex-row-end" style={styles.btnsContainer}>
                <Button
                  style={styles.btnGray}
                  type="button"
                  onClick={cancelBtnHandler}
                  data-testid="cancel-resent-invite-modal-button"
                >
                  {t('Cancel')}
                </Button>

                <LoadingButton
                  className="vl-button vl-font-regular"
                  onClick={sendBtnHandler}
                  loading={loading_create}
                  disabled={loading_create}
                  data-testid="send-resent-invite-button"
                >
                  {t('Send')}
                </LoadingButton>
              </div>
            </Col>
          </Row>
        </ModalBody>
      </Modal>

      <ErrorModal
        title="Failed to resend invitation"
        subTitle={errorMessage}
        open={errorModalOpen}
        onCancel={() => setErrorModalOpen(false)}
        data-testid="resent-invite-error-modal"
      />
    </>
  );
};

export { ResentInvite };

const styles = {
  container: { padding: '30px' },
  btnGray: {
    width: '110px',
    backgroundColor: 'var(--productGray)',
    fontSize: '14px',
    padding: '4px 10px',
    borderColor: 'var(--productGray)',
    marginRight: '10px'
  },
  subText: {
    color: 'var(--productGray)',
    fontSize: '14px',
    marginTop: '30px',
    marginBottom: '30px'
  },
  btnsContainer: { marginBottom: '30px', marginTop: '30px', width: '100%' },
  title: { color: 'var(--productPink)', fontWeight: 'bold' },
  titleHolder: { fontSize: '30px' }
};
